import axios from 'axios'

export const getAllRegion = (configs) => {
  let remoteUrl = 'regions'
  return axios.get(remoteUrl, {params: configs.params})
}

export const getRegion = (configs) => {
  let remoteUrl = 'regions/' + configs.id

  return axios.get(remoteUrl, {params: configs.params})
}

export const addRegion = (data, configs) => {
  let remoteUrl = 'regions'

  return axios.post(remoteUrl, data)
}

export const editRegion = (data, configs) => {
  let remoteUrl = 'regions/' + configs.id

  return axios.put(remoteUrl, data)
}

export const deleteRegion = (id) => {
  let remoteUrl = 'regions/' + id

  return axios.delete(remoteUrl)
}

export const restoreRegion = (id) => {
  return axios.post('regions/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/regions.js